import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useCarUsersGroupsStore = defineStore('car-users-groups', () => {

    const configStore = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore = useTokenStore()

    const carUsersGroups = ref({})
    const carUsersGroupsProcess = ref(false)
    const carUsersGroupsMsg = ref({})

    const carUsersGroupsCreateList = ref({})
    const carUsersGroupsCreateListProcess = ref(false)
    const carUsersGroupsCreateListMsg = ref({})

    const carUsersGroupsCreateProcess = ref(false)
    const carUsersGroupsCreateMsg = ref({})

    const carUsersGroupsUpdateProcess = ref(false)
    const carUsersGroupsUpdateMsg = ref({})

    const carUsersGroupsDeleteProcess = ref(false)
    const carUsersGroupsDeleteMsg = ref({})

    async function createCarUsersGroups(payload) {

        carUsersGroupsCreateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups/links/cars`, 
                method: 'POST', 
                token,
                data: payload
            })

            if(!request.error) {
                carUsersGroupsCreateMsg.value = { success: true, text: 'CAR_RIGHTS_USERS_GROUPS_CREATE_SUCCESS' }
            } else {
                carUsersGroupsCreateMsg.value = { success: false, text: request.error }
            }

        } else {
            carUsersGroupsCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carUsersGroupsCreateProcess.value = false
    }

    async function readCarUsersGroups(payload) {

        carUsersGroupsProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups/links/cars${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                if(request.ugroups.length) {
                    carUsersGroups.value = request
                    carUsersGroupsMsg.value = { success: true }
                } else if(!request.ugroups.length) {
                    carUsersGroups.value = {}
                    carUsersGroupsMsg.value = { success: false, text: 'CAR_USERS_GROUPS_EMPTY' }
                }
            } else {
                carUsersGroups.value = {}
                carUsersGroupsMsg.value = { success: false, text: request.error }
            }

        } else {

            carUsersGroupsMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carUsersGroupsProcess.value = false
        return carUsersGroups.value
    }

    async function readCarUsersGroupsList(payload) {

        carUsersGroupsCreateListProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                carUsersGroupsCreateList.value = request
                carUsersGroupsCreateListMsg.value = { success: true }
            } else {
                carUsersGroupsCreateList.value = {}
                carUsersGroupsCreateListMsg.value = { success: false, text: request.error }
            }

        } else {

            carUsersGroupsCreateListMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carUsersGroupsCreateListProcess.value = false
        return carUsersGroupsCreateList.value
    }

    async function updateCarUsersGroup(payload) {

        carUsersGroupsUpdateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups/links/cars`, 
                method: 'PUT', 
                token,
                data: payload
            })

            if(!request.error) {
                carUsersGroupsUpdateMsg.value = { success: true, text: 'CAR_RIGHTS_USERS_GROUPS_UPDATE_SUCCESS' }
            } else {
                carUsersGroupsUpdateMsg.value = { success: false, text: request.error }
            }

        } else {
            carUsersGroupsUpdateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carUsersGroupsUpdateProcess.value = false
    }

    async function deleteCarUsersGroups(payload) {

        carUsersGroupsDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups/links/cars${params}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {
                carUsersGroupsDeleteMsg.value = { success: true, text: 'CAR_RIGHTS_USERS_GROUPS_DELETE_SUCCESS' }
            } else {
                carUsersGroupsDeleteMsg.value = { success: false, text: request.error }
            }

        } else {
            carUsersGroupsDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        carUsersGroupsDeleteProcess.value = false
    }

    const setCarUsersGroupsCreateMsg = data => carUsersGroupsCreateMsg.value = data
    const setCarUsersGroupsUpdateMsg = data => carUsersGroupsUpdateMsg.value = data
    const setCarUsersGroupsDeleteMsg = data => carUsersGroupsDeleteMsg.value = data

    return {

        carUsersGroups,
        carUsersGroupsProcess,
        carUsersGroupsMsg,
        carUsersGroupsCreateList,
        carUsersGroupsCreateListProcess,
        carUsersGroupsCreateListMsg,
        carUsersGroupsCreateProcess,
        carUsersGroupsCreateMsg,
        carUsersGroupsUpdateProcess,
        carUsersGroupsUpdateMsg,
        carUsersGroupsDeleteProcess,
        carUsersGroupsDeleteMsg,
        createCarUsersGroups,
        readCarUsersGroups,
        readCarUsersGroupsList,
        updateCarUsersGroup,
        deleteCarUsersGroups,
        setCarUsersGroupsCreateMsg,
        setCarUsersGroupsUpdateMsg,
        setCarUsersGroupsDeleteMsg
    }
})
